<script lang="ts" setup>
import type { FilterGroupMultiSelect, FilterOptionMultiSelect } from "~~/models/filters";
import type { PropertyFilterDto } from "~~/server/api/ecom/products/search.post";
import type { CatalogPageRecord } from "~~/server/graphql/datocms/generated";

const { cmsData } = defineProps<{ cmsData: CatalogPageRecord }>();

const { loggedIn } = useUserSession();

const { searchState, activeFilters } = useCatalog({
  initialize: {
    searchState: false,
    catalog: false,
    ssr: !loggedIn.value,
    scrollIntoViewThreshold: 500,
  },
});

function getFilterLabelValue(activeFilter: PropertyFilterDto): string {
  const filter = searchState.value.propertyFilters.find((pf: FilterGroupMultiSelect) => pf.id === activeFilter.propertyId);
  const option = filter?.options.find((o: FilterOptionMultiSelect) => o.value === activeFilter.propertyValueId);

  return option ? `${filter.title}: <span class="font-semibold">${option.label}</span>` : "";
}

function onDeactivateAllFilters() {
  for (const filter of searchState.value.propertyFilters) {
    filter.selectedList = [];
  }
}

function onDeactivateFilter(activeFilter: PropertyFilterDto) {
  const filter = searchState.value.propertyFilters.find((pf: FilterGroupMultiSelect) => pf.id === activeFilter.propertyId);

  if (!filter) {
    return;
  }

  filter.selectedList = filter.selectedList.filter((i: number) => i !== activeFilter.propertyValueId);
}
</script>

<template>
  <div class="gap-x-xl gap-y-md flex flex-col lg:flex-row lg:flex-wrap">
    <div
      class="gap-xs text-primary order-2 flex cursor-pointer items-center lg:order-1"
      @click="onDeactivateAllFilters"
    >
      {{ cmsData.overviewActionDeactivateAllFilters }}
      <UIcon name="i-ph-x" />
    </div>

    <div
      v-for="activeFilter of activeFilters" :key="activeFilter.propertyId"
      class="gap-xs order-1 flex cursor-pointer items-center lg:order-2"
      @click="onDeactivateFilter(activeFilter)"
    >
      <span v-html="getFilterLabelValue(activeFilter)" />
      <UIcon name="i-ph-x" />
    </div>
  </div>
</template>

<style scoped>

</style>
